import {send} from "@/composables/apiClient";
import {refreshMenuCounts} from "@/composables/useMenuCounts";
import {useSnackbarStore} from "@/stores/snackBarStore";
import {apiError} from "@/components/drivers/shifts/shiftFormat";

// Raise a maintenance work order for a defect; true when it was created.
export const createDefectWorkOrder = async (defect) => {
    const {showSnackbar} = useSnackbarStore();
    try {
        await send("post", `fleet/inspection-defects/${defect.id}/work-order`);
        showSnackbar("Work order created.", "success");
        refreshMenuCounts();
        return true;
    } catch (e) {
        showSnackbar(apiError(e, "Could not create the work order."), "error");
        return false;
    }
};

// The asset page's Maintenance Services tab, where the work order lives.
export const workOrderRoute = (defect) => ({name: "asset", params: {asset: defect.asset_id}, query: {tab: 1}});

// VehicleServiceTaskStatusEnum: 1 pending, 2 skipped, 3 completed.
export const workOrderStatusLabel = (s) => ({1: "Pending", 2: "Skipped", 3: "Completed"}[Number(s)] || "");
